import Headers from 'fetch-headers';
var baseURL = '/api/v1/';

/**
 * AJAX/Fetch request config
 */
var requestSettings = function requestSettings() {
  return {
    method: 'GET',
    headers: new Headers([['accept', 'application/json'], ['X-Requested-With', 'XMLHttpRequest']]),
    mode: 'cors',
    cache: 'default',
    credentials: 'include'
  };
};

/**
 * API endpoints map - resource name to URL
 * @type {[*]}
 */
var apiMap = {
  products: 'products',
  sectors: 'products/sectors',
  usages: 'products/usages',
  materials: 'products/materials',
  resources: 'resources',
  types: 'resources/types',
  searchProducts: 'search/product/?query=',
  searchResources: 'search/resource/?query='
};

/**
 * Perform fetch request to API
 * @param url
 * @param method
 * @param data
 */
var request = function request(url) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  var data = arguments.length > 2 ? arguments[2] : undefined;
  var settings = requestSettings();
  // check if the API supports the URL
  if (!apiMap[url]) {
    throw new Error("The URL \"".concat(url, "\" is not supported by the API"));
  }
  settings.method = method;
  var query = data;
  if (!data) query = '';

  // console.debug(`${baseURL}${apiMap[url]}${query}`);

  return fetch("".concat(baseURL).concat(apiMap[url]).concat(query), settings).then(function (response) {
    if (response.ok) {
      // try for a JSON response - fall back to text
      var responseCopy = response.clone();
      return responseCopy.json()["catch"](function () {
        return response.text();
      });
    }
    // TODO: show a global notification?
    throw new Error('There has been a problem with your request');
  });
};
export default {
  request: request
};